import { Card } from "../../models/card";
export class GreenGem extends Card {
}
GreenGem.displayName = "Green Gem";
GreenGem.artUrl = "./assets/cards/greengem.jpg";
